import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { callGetNFTCollectionAssets } from '@app/client/resources/yat-pages/page-items';
import { PathParams } from '@app/routes/types';

export const useNFTCollectionAssetsFromParams = () => {
    const { [PathParams.Contract]: contract, [PathParams.Id]: itemId } = useParams();

    const cache = ['CollectionAssets', contract, itemId];

    return useQuery({
        queryKey: cache,
        queryFn: ({ signal }) =>
            callGetNFTCollectionAssets({
                contract: contract || '',
                itemId: itemId || '',
                settings: {
                    signal,
                },
            }),
        retry: false,
        enabled: Boolean(contract && itemId),
    });
};
